<template>
  <div class="dashboard-content-container">
    <div class="dashboard-content-inner">
      <div class="dashboard-headline">
        <h3>All your Jobs</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>All your Jobs</li>
          </ul>
        </nav>
      </div>

      <table class="table table-striped table-hover">
        <caption>
          List of jobs
        </caption>
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Project Title</th>
            <th scope="col">Date Created</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tr v-if="projects.length == 0">You currently do not have any jobs</tr>
        <tbody v-else>   
          <tr v-for="(project, index) in projects" :key="project.id" >
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ project.title }}</td>
            <td>{{ project.created_at.slice(0, 10) }}</td>
            <td>
              <modal 
              @clicked="showModal(index)" 
              :id="index" 
              :toggled="dropdownToggle" 
              :amountpaid="project.amount_paid | addCommaToAmount" 
              @pay="makePayment($event)"
              v-model="amount"
              :project_id="project.id"
              />
            </td>
            <td>
              <router-link :to="`/dashboard/jobs/viewproject/${project.id}`" @click="disableEdit">
              View Project
              </router-link>
            
            </td>
            
          </tr>
         
        </tbody>
      </table>
    </div>
     
  </div>
 
</template>

<script>
/* eslint-disable no-console */

import { getCall, postCall, deleteCall } from "../../../core/services/http.service";
import { INITIATE_PROJECT_PAYMENT } from "../../../core/config/endpoints/project-payment";
import { DELETE_PROJECT, PUBLISH_PROJECT,ALL_MY_PROJECTS } from "../../../core/config/endpoints/projects";
import Modal from './Modal.vue';

export default {
  name: "DraftProjects",
 
  components: {Modal},
  data() {
    return {
      projects: [],
      isClicked: false,
      amount: null,
      dropdownToggle: null,
      isEmpty: false
    };
  },
 created() {
    this.myPublishedProjects()
    console.log(this.isDisabled)
  },
  filters: {
    addCommaToAmount(amount){
     return amount.toLocaleString();
    }
  },
  methods: {
   
    myPublishedProjects(){
      this.$store.commit("setIsLoaded", true);
       getCall(ALL_MY_PROJECTS)
       .then((response) => {
         console.log(response)
        if(response.status === 200){
           if(response.data.data.data.length === 0){
              this.isEmpty = true
           }else{
               this.isEmpty = false
           }
            this.projects = response.data.data.data;
          }else{
            console.log('error')
          }
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
   
    makePayment(e) {
      this.isClicked = true
      this.$store.commit("setIsLoaded", true);
      postCall(INITIATE_PROJECT_PAYMENT, {
        project_id: Number(e),
        callback_url: "http://localhost:8080/verifytransaction",
        amount:  Number(this.amount.replace(/,/g, ""))
      })
        .then((response) => {
          window.location.href = response.data.data.authorization_url;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    showModal(id) {
      if (this.dropdownToggle === id) {
        this.dropdownToggle = null;
      } else {
        this.dropdownToggle = id;
      }
    },
    publishProject(projectId) {
        this.$store.commit('setIsLoaded', true);
        getCall(PUBLISH_PROJECT.PROJECT_ID(projectId))
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
      },
    deleteProject(projectId, index) {
    let response =  confirm('Are you sure you want to delete this project?')
     console.log(response)
     if(response === true){
        this.$store.commit('setIsLoaded', true);
        this.projects.splice(index, 1)
        deleteCall(DELETE_PROJECT, { data:{
           project_id: projectId,
        }  
        })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            this.$toast.error(`${error.response.data.message}`);
          })
          .finally(() => {
            this.$store.commit('setIsLoaded', false);
          });
     }
      },
  },
};
</script>

<style scoped>

</style>
